import { axiosInstance } from "../apiurls/apiurls";
import {
  GET_ALL_SUBTOPICS,
  GET_SUBTOPIC_BY_KEY,
  GET_ALL_SUBTOPIC_PAGE_CONTENT,
  GET_SUBTOPIC_PAGE_CONTENT_BY_ID,
  GET_ALL_SUBTOPIC_INSTITUTION_PAGE_CONTENT,
  GET_SUBTOPIC_INSTITUTION_PAGE_CONTENT_BY_ID,
  GET_ONE_SUBTOPIC_COMPLETED_URL,
  SUBMIT_CONTENT_QUIZ_URL,
  REGENERATE_CONTENT_QUIZ_URL,
} from "../apiurls/apiurls";


export const getAllSubtopics = async (topicKey) => {
  try {
    const response = await axiosInstance.get(`${GET_ALL_SUBTOPICS}?topic_key=${topicKey}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching subtopics:", error);
    throw error;
  }
};

export const getSubtopicByKey = async (key) => {
  try {
    const response = await axiosInstance.get(`${GET_SUBTOPIC_BY_KEY}?key=${key}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching subtopic by key:", error);
    throw error;
  }
};

export const getAllSubtopicPageContent = async (subtopicKey) => {
  try {
    const response = await axiosInstance.get(
      `${GET_ALL_SUBTOPIC_PAGE_CONTENT}?subtopic_key=${subtopicKey}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching all subtopic page content:", error);
    throw error;
  }
};

export const getSubtopicPageContentById = async (id) => {
  try {
    const response = await axiosInstance.get(
      `${GET_SUBTOPIC_PAGE_CONTENT_BY_ID}?id=${id}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching subtopic page content by id:", error);
    throw error;
  }
};

export const getAllSubtopicInstitutionPageContent = async (subtopicKey) => {
  try {
    const response = await axiosInstance.get(
      `${GET_ALL_SUBTOPIC_INSTITUTION_PAGE_CONTENT}?subtopic_key=${subtopicKey}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching all subtopic institution page content:", error);
    throw error;
  }
};

export const getSubtopicInstitutionPageContentById = async (id) => {
  try {
    const response = await axiosInstance.get(
      `${GET_SUBTOPIC_INSTITUTION_PAGE_CONTENT_BY_ID}?id=${id}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching subtopic institution page content by id:", error);
    throw error;
  }
};

export const getOneSubtopicCompletedApi = async (pageId) => {
  try {
    const response = await axiosInstance.get(
      `${GET_ONE_SUBTOPIC_COMPLETED_URL}?page_id=${pageId}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching one subtopic completed:", error);
    throw error;
  }
};

export const submitContentQuizApi = async (pageTitle, pageKey, activeId, payload) => {
  try {
    const response = await axiosInstance.post(
      `${SUBMIT_CONTENT_QUIZ_URL}?title=${pageTitle}&key=${pageKey}&page_content_id=${activeId}`,
      payload
    );
    return response.data;
  } catch (error) {
    console.error("Error submitting content quiz:", error);
    throw error;
  }
};

export const regenerateContentQuizApi = async (pageTitle, pageKey, activeId) => {
  try {
    const response = await axiosInstance.post(
      `${REGENERATE_CONTENT_QUIZ_URL}?title=${pageTitle}&key=${pageKey}&active_id=${activeId}`,
      {}
    );
    return response.data;
  } catch (error) {
    console.error("Error regenerating content quiz:", error);
    throw error;
  }
};


